import {
  HttpMethod,
  HttpModel,
  PaginationModel,
} from '@/Shared/domain'
import {
  axiosFetch,
  createQueryString,
} from '@/Shared/infrastructure'
import { getAccessRolesData } from '@/Shared/infrastructure/endpoints'
import { AccessRolesModel, AccessRolesRepository } from '../domain'

export function createApiAccessRolesRepository(): AccessRolesRepository {
  return new ApiAccessRolesRepository()
}

type ApiAccessRoles = {
  rows: AccessRolesModel[]
  totalRows: number
}

const convertToDomain = (response: ApiAccessRoles): PaginationModel<AccessRolesModel> => {
  if (!response?.rows) {
    return {
      rows: [],
      totalRows: 0,
    }
  }

  return {
    rows: response.rows.map(
      (profile): AccessRolesModel => ({
        name: profile.name,
        email: profile.email,
        enabled: profile.enabled,
        rolName: profile.rolName,
        userName: profile.userName,
        surname: profile.surname,
        surname2: profile.surname2,
      }),
    ),
    totalRows: response.totalRows,
  }
}

export class ApiAccessRolesRepository implements AccessRolesRepository {
  async GetAccessRolesData(
    pageNumber: number,
    numberOfRecordsPerPage: number,
  ): Promise<HttpModel<PaginationModel<AccessRolesModel>>> {    
    const response = await axiosFetch(
      getAccessRolesData.concat(
        createQueryString({
          numberOfRecordsPerPage: numberOfRecordsPerPage.toString(),
          pageNumber: (pageNumber - 1).toString(),
        }),
      ),
      HttpMethod.GET,
      {},
    )

    return {
      data: convertToDomain(response.data),
      meta: response.meta,
    }
  }
}